window.DRKALLA_HAIR_ANALYSIS = {
 "generatedAt": "2026-10-03T11:48:14.522Z",
 "catalogFetchedAt": "2026-10-03T11:32:26.762Z",
 "source": "Shopify Admin catalog (active, online store, available); groups from title, product type and benefit tags; generator: haaranalyse-2026-10-03/build-data.mjs",
 "products": [
  {
   "url": "/products/restrukturierendes-shampoo-bio-mandel-extrakt-500ml",
   "title": "Evelon Pro NutriElements Repair Shampoo mit Bio-Mandelextrakt 500 ml",
   "groups": [
    "cleansing",
    "moisture",
    "repair"
   ],
   "strong": [
    "moisture",
    "repair"
   ],
   "role": "Reinigung",
   "rank": 0
  },
  {
   "url": "/products/regenerierende-maske-bio-mandelextrakt-geschadigtes-haar-500ml",
   "title": "Evelon Pro NutriElements Repair Haarmaske mit Bio-Mandelextrakt 500 ml",
   "groups": [
    "mask",
    "moisture",
    "repair"
   ],
   "strong": [
    "moisture",
    "repair"
   ],
   "role": "Pflege",
   "rank": 1
  },
  {
   "url": "/products/amplifier-cream-150-ml",
   "title": "Black Professional Line Rose Curly Dream Lockencreme, 150 ml",
   "groups": [
    "curl"
   ],
   "strong": [
    "curl",
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 2
  },
  {
   "url": "/products/ultra-strong-styling-schaum-anti-feuchtigkeit-locken-400ml",
   "title": "Black Professional Line Ultra Strong Schaumfestiger 400 ml",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 3
  },
  {
   "url": "/products/glaettendes-shampoo-anti-frizz-bio-baobaboel-spliss-vorbeugen",
   "title": "Evelon Pro Nutri Elements Total Control Anti-Frizz-Shampoo – 500 ml",
   "groups": [
    "cleansing",
    "moisture",
    "frizzSmoothing",
    "repair"
   ],
   "strong": [
    "moisture",
    "frizzSmoothing"
   ],
   "role": "Reinigung",
   "rank": 4
  },
  {
   "url": "/products/curly-dream-shampoo-locken-bio-baobaoel-frizz-kontrolle",
   "title": "Black Professional Line Rose Curly Dream Locken-Shampoo",
   "groups": [
    "cleansing",
    "curl",
    "moisture",
    "frizzSmoothing",
    "repair"
   ],
   "strong": [
    "curl"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 5
  },
  {
   "url": "/products/reparierendes-shampoo-keratin-grossgebinde-1000ml",
   "title": "Black Professional Line Perlé Shampoo mit Keratin 1000 ml",
   "groups": [
    "cleansing",
    "repair",
    "volume"
   ],
   "strong": [
    "repair"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 6
  },
  {
   "url": "/products/haarspray-ultra-starker-halt-anti-frizz-feuchtigkeitsschutz",
   "title": "Black Professional Line Ultra Strong Anti-Frizz-Haarspray",
   "groups": [
    "frizzSmoothing",
    "stylingHold"
   ],
   "strong": [
    "frizzSmoothing",
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 7
  },
  {
   "url": "/products/visage-extra-hold-styling-gel-super-starker-halt-350ml",
   "title": "VISAGE Haar styling Gel & Extra Halt Super Starker Halt 350 ml",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 8
  },
  {
   "url": "/products/visage-super-hold-styling-gel-rueckstandsfrei-350ml",
   "title": "VISAGE Haar Styling Gel & Super starker Halt für Frisuren, 350 ml",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 9
  },
  {
   "url": "/products/visage-wet-look-styling-gel-nass-look-glanzeffekt-350ml",
   "title": "VISAGE Haar Styling Gel & Wet Look Brillanter Nass Effekt 350ml",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 10
  },
  {
   "url": "/products/haarspray-volumen-glanz-langanhaltender-halt",
   "title": "Elegans Haarspray für Volumen und Glanz",
   "groups": [
    "volume",
    "stylingHold"
   ],
   "strong": [
    "volume",
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 11
  },
  {
   "url": "/products/ultra-strong-haargel-extreme-hold-styling",
   "title": "Black Professional Line Ultra Strong – Haargel, extra starker Halt",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 12
  },
  {
   "url": "/products/haarschaum-volumen-glanz-extra-starker-halt",
   "title": "Elegans Volumen-Schaumfestiger, extra starker Halt – 400 ml",
   "groups": [
    "volume",
    "stylingHold"
   ],
   "strong": [
    "volume",
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 13
  },
  {
   "url": "/products/pflegende-haarmaske-mit-arganol",
   "title": "Black Professional Line Argan Treatment Haarmaske – 250 ml",
   "groups": [
    "mask",
    "moisture",
    "repair"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Pflege",
   "rank": 14
  },
  {
   "url": "/products/lch-hairspray-evelon-pro",
   "title": "Evelon Pro LCH – Haarspray mit starkem Halt, 500 ml",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 15
  },
  {
   "url": "/products/haarschaum-volumen-locken-styling-haarstyling-profi",
   "title": "Evelon Pro MOU Volumen-Schaumfestiger – 300 ml",
   "groups": [
    "volume",
    "stylingHold"
   ],
   "strong": [
    "volume",
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 16
  },
  {
   "url": "/products/haarspray-extra-starker-halt-volumen-glanz",
   "title": "Black Professional Line Extra Strong Haarspray",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 17
  },
  {
   "url": "/products/noir-reparaturol-mit-kaktusfeigensaft",
   "title": "Black Professional Line Noir Repair Haaröl – 100 ml",
   "groups": [
    "repair"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 18
  },
  {
   "url": "/products/psn-essense-reparatur-maske-500-ml-hydrieren-mit-keratin",
   "title": "Evelon Pro PSN Essense Repair Haarmaske mit Keratin",
   "groups": [
    "mask",
    "repair",
    "moisture"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 19
  },
  {
   "url": "/products/turquoise-hydra-complex-feuchtigkeitsmaske-fur-feines-haar",
   "title": "Black Professional Line Turquoise Hydra Complex Feuchtigkeitsmaske für feines Haar",
   "groups": [
    "mask",
    "moisture",
    "repair",
    "volume"
   ],
   "strong": [
    "moisture",
    "repair",
    "volume"
   ],
   "role": "Pflege",
   "rank": 20
  },
  {
   "url": "/products/black-professional-keratin-shampoo-trockenes-strapaziertes-haar",
   "title": "Black Professional Keratin-Shampoo für trockenes und strapaziertes Haar, 250 ml",
   "groups": [
    "cleansing",
    "moisture",
    "repair"
   ],
   "strong": [
    "moisture",
    "repair"
   ],
   "role": "Reinigung",
   "rank": 21
  },
  {
   "url": "/products/restrukturierende-maske-keratin-protein-black-professional-250ml",
   "title": "Black Professional Line Keratin-Maske für strapaziertes Haar, 250 ml",
   "groups": [
    "mask",
    "repair"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 22
  },
  {
   "url": "/products/flussigkristalle-leinol-arganol-cuticle-glatzung-glanz",
   "title": "Evelon Pro CRS Fluid Crystals Haarserum mit Arganöl und Leinöl",
   "groups": [
    "moisture",
    "frizzSmoothing",
    "repair"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Pflege",
   "rank": 23
  },
  {
   "url": "/products/noir-repair-shampoo-mit-kaktusfeigensaft",
   "title": "Black Professional Line Noir Repair Shampoo",
   "groups": [
    "cleansing",
    "repair",
    "moisture"
   ],
   "strong": [
    "repair"
   ],
   "role": "Reinigung",
   "rank": 24
  },
  {
   "url": "/products/restrukturierende-maske-kakao-keratin",
   "title": "Black Professional Line Repair-Haarmaske mit Kakao und Keratin 500 ml",
   "groups": [
    "mask",
    "repair",
    "moisture"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 25
  },
  {
   "url": "/products/restrukturierung-styling-schaum-volumen-locken-400ml",
   "title": "Black Professional Line Equal Strong – Schaumfestiger, starker Halt, 400 ml",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 26
  },
  {
   "url": "/products/volumen-puder-matt-effekt-feines-haar-textur-8g",
   "title": "Black Professional Line 3D Hair Powder Volumenpuder 8 g",
   "groups": [
    "volume",
    "stylingHold"
   ],
   "strong": [
    "volume",
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 27
  },
  {
   "url": "/products/performance-extra-strong-wella-500-ml",
   "title": "Wella Professionals Performance Extra Strong Haarspray, 500 ml",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 28
  },
  {
   "url": "/products/farbschutz-conditioner",
   "title": "Black Professional Line Farbschutz-Conditioner – 500 ml",
   "groups": [
    "conditioner",
    "colorCare"
   ],
   "strong": [
    "colorCare"
   ],
   "role": "Pflege",
   "rank": 29
  },
  {
   "url": "/products/farbschutzshampoo",
   "title": "Black Professional Line Farbschutzshampoo – 500 ml",
   "groups": [
    "cleansing",
    "colorCare"
   ],
   "strong": [
    "colorCare"
   ],
   "role": "Reinigung",
   "rank": 30
  },
  {
   "url": "/products/anti-frizz-haarmaske-geschmeidigkeit-elastizitaet-arganoel",
   "title": "Evelon Pro Nutri Elements Total Control – Anti-Frizz-Haarmaske, 500 ml",
   "groups": [
    "mask",
    "moisture",
    "frizzSmoothing"
   ],
   "strong": [
    "moisture",
    "frizzSmoothing"
   ],
   "role": "Pflege",
   "rank": 31
  },
  {
   "url": "/products/feuchtigkeitsspendendes-shampoo-feines-haar-hydra-complex",
   "title": "Black Professional Line Turquoise Hydra Complex Shampoo für feines Haar",
   "groups": [
    "cleansing",
    "moisture",
    "repair",
    "volume"
   ],
   "strong": [
    "moisture",
    "repair",
    "volume"
   ],
   "role": "Reinigung",
   "rank": 32
  },
  {
   "url": "/products/nahrendes-shampoo-sanfte-reinigung-feines-haar-bio-hafer",
   "title": "Evelon Pro Nutri Elements Daily Shampoo für feines Haar – 500 ml",
   "groups": [
    "cleansing",
    "moisture",
    "volume",
    "repair"
   ],
   "strong": [
    "moisture",
    "volume"
   ],
   "role": "Reinigung",
   "rank": 33
  },
  {
   "url": "/products/pflegemaske-trockenes-feines-haar-bio-hafer-volumen-500ml",
   "title": "Evelon Pro Nutri Elements Daily Haarmaske – 500 ml",
   "groups": [
    "mask",
    "moisture",
    "volume",
    "repair"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Pflege",
   "rank": 34
  },
  {
   "url": "/products/reparierendes-shampoo-sls-frei-oxidationsschutz-1000ml",
   "title": "Black Professional Line Jade Supreme Solution Repair-Shampoo",
   "groups": [
    "cleansing",
    "repair"
   ],
   "strong": [
    "repair"
   ],
   "role": "Reinigung",
   "rank": 35
  },
  {
   "url": "/products/spray-conditioner-feuchtigkeit-haarbruch-schutz-200ml",
   "title": "Black Professional Line 2-Phasen-Spray-Conditioner 200 ml",
   "groups": [
    "conditioner",
    "moisture",
    "repair",
    "volume"
   ],
   "strong": [],
   "role": "Pflege",
   "rank": 36
  },
  {
   "url": "/products/mousse-mit-linseed-extract-modellieren",
   "title": "Lin Exance Styling-Mousse mit Leinsamenextrakt – 200 ml",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 37
  },
  {
   "url": "/products/blanc-volume-up-volumising-maske",
   "title": "Black Professional Line Blanc Volume Up – Volumen-Haarmaske",
   "groups": [
    "mask",
    "volume",
    "moisture",
    "repair"
   ],
   "strong": [
    "volume"
   ],
   "role": "Pflege",
   "rank": 38
  },
  {
   "url": "/products/blond-booster-gelb-neutralisation-kuehle-brillanz",
   "title": "Black Professional Line Platinum No Yellow Absolute Blond Booster – Leave-in-Pflege, 125 ml",
   "groups": [
    "antiYellow"
   ],
   "strong": [
    "antiYellow"
   ],
   "role": "Pflege",
   "rank": 39
  },
  {
   "url": "/products/farbschutz-maske-entwirrende-pflege-coloriertes-haar",
   "title": "Evelon Pro CLR Color System Farbschutzmaske – 500 ml",
   "groups": [
    "mask",
    "colorCare",
    "moisture",
    "repair"
   ],
   "strong": [
    "colorCare"
   ],
   "role": "Pflege",
   "rank": 40
  },
  {
   "url": "/products/osis-dust-it-volume-powder",
   "title": "Schwarzkopf Professional OSiS+ Dust It Volumenpuder – 10 g",
   "groups": [
    "volume",
    "stylingHold"
   ],
   "strong": [
    "volume",
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 41
  },
  {
   "url": "/products/10-in-1-spray-maske-feuchtigkeit-reparatur-200ml",
   "title": "Black Professional Line 10-in-1 Spray-Maske, 200 ml",
   "groups": [
    "mask",
    "frizzSmoothing",
    "colorCare",
    "moisture",
    "repair",
    "volume"
   ],
   "strong": [],
   "role": "Pflege",
   "rank": 42
  },
  {
   "url": "/products/nahrendes-haarspray-starkes-fixierung-arganoel",
   "title": "Black Professional Line Doré Haarspray mit starkem Halt – 500 ml",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "moisture",
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 43
  },
  {
   "url": "/products/black-star-shine-finish-glanzspray-125ml",
   "title": "Black Professional Line Black Star – Glanzspray, 125 ml",
   "groups": [
    "stylingHold"
   ],
   "strong": [
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 44
  },
  {
   "url": "/products/feuchtigkeitsspendende-maske-fur-trockenes-ausgetrocknetes-haar",
   "title": "Black Professional Line Feuchtigkeitsmaske für trockenes Haar – 500 ml",
   "groups": [
    "mask",
    "moisture",
    "repair"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Pflege",
   "rank": 45
  },
  {
   "url": "/products/transparente-flussigkristalle-leinol-cuticle-versiegelung",
   "title": "Black Professional Line Transparent Liquid Crystals Haarserum mit Leinsamenöl, 100 ml",
   "groups": [
    "frizzSmoothing",
    "moisture",
    "repair"
   ],
   "strong": [],
   "role": "Pflege",
   "rank": 46
  },
  {
   "url": "/products/detox-haarmaske-bio-ingwer-extrakt-tiefenreinigung-500ml",
   "title": "Evelon Pro Nutri Elements Detox – Haarmaske mit Bio-Ingwer, 500 ml",
   "groups": [
    "mask",
    "moisture",
    "repair"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Pflege",
   "rank": 47
  },
  {
   "url": "/products/detox-shampoo-tiefenreinigung-kopfhaut-balance",
   "title": "Evelon Pro Nutri Elements Detox – Tiefenreinigendes Shampoo, 500 ml",
   "groups": [
    "cleansing",
    "moisture",
    "repair"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Reinigung",
   "rank": 48
  },
  {
   "url": "/products/leinol-flussigkristalle-glanzschutz-spliss-regeneration",
   "title": "Black Professional Line Flüssigkristall-Haarserum mit Leinöl – 100 ml",
   "groups": [
    "frizzSmoothing",
    "moisture",
    "repair"
   ],
   "strong": [],
   "role": "Pflege",
   "rank": 49
  },
  {
   "url": "/products/regenerierende-8-sekunden-kur-lamellare-technologie-200ml",
   "title": "Black Professional Line Jade Supreme Solution – Regenerierende 8-Sekunden-Kur, 200 ml",
   "groups": [
    "repair",
    "moisture"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 50
  },
  {
   "url": "/products/anti-gelb-shampoo",
   "title": "Black Professional Line Yellow Stop – Silbershampoo, 500 ml",
   "groups": [
    "cleansing",
    "antiYellow"
   ],
   "strong": [
    "antiYellow"
   ],
   "role": "Reinigung",
   "rank": 51
  },
  {
   "url": "/products/anti-frizz-shampoo",
   "title": "Black Professional Line Frizz Free – Anti-Frizz-Shampoo, 500 ml",
   "groups": [
    "cleansing",
    "frizzSmoothing"
   ],
   "strong": [
    "frizzSmoothing"
   ],
   "role": "Reinigung",
   "rank": 52
  },
  {
   "url": "/products/anti-frizz-oil-shampoo",
   "title": "Black Professional Line Frizz Free Oil No Oil – Anti-Frizz-Haarpflege, 500 ml",
   "groups": [
    "frizzSmoothing",
    "moisture",
    "repair"
   ],
   "strong": [
    "frizzSmoothing"
   ],
   "role": "Pflege",
   "rank": 53
  },
  {
   "url": "/products/laminier-spray-b3-plex-keravis-ceramide-hitzeschutz-leave-in",
   "title": "Black Professional Line Argent Laminier-Spray mit Hitzeschutz – 200 ml",
   "groups": [
    "heatProtection"
   ],
   "strong": [
    "heatProtection"
   ],
   "role": "Hitzeschutz",
   "rank": 54
  },
  {
   "url": "/products/glaettende-haarmaske-anti-frizz-kollagen-500ml",
   "title": "KYO Smooth System Anti-Frizz-Haarmaske – 500 ml",
   "groups": [
    "mask",
    "frizzSmoothing"
   ],
   "strong": [
    "frizzSmoothing"
   ],
   "role": "Pflege",
   "rank": 55
  },
  {
   "url": "/products/keratin-protein-seidenprotein-leave-in-restructuring-vial",
   "title": "Black Professional Line Keratin Protein Booster Haarampullen – 12 × 10 ml",
   "groups": [
    "repair",
    "moisture"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 56
  },
  {
   "url": "/products/restrukturierendes-shampoo-fur-trockenes-und-strapaziertes-haar",
   "title": "Black Professional Line Repair-Shampoo mit Kakao und Keratin 500 ml",
   "groups": [
    "cleansing",
    "repair"
   ],
   "strong": [
    "repair"
   ],
   "role": "Reinigung",
   "rank": 57
  },
  {
   "url": "/products/restrukturierende-ampullen-haarfaser-rekonstruktion",
   "title": "Lin Exance Repair-Haarampullen mit Leinsamenextrakt 12 × 10 ml",
   "groups": [
    "repair"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 58
  },
  {
   "url": "/products/glaettendes-hitzeschutz-spray-styling-anti-frizz-200ml",
   "title": "KYO Smooth System Glättungsspray – 200 ml",
   "groups": [
    "frizzSmoothing",
    "heatProtection"
   ],
   "strong": [
    "frizzSmoothing",
    "heatProtection"
   ],
   "role": "Hitzeschutz",
   "rank": 59
  },
  {
   "url": "/products/leave-in-spray-hitzeschutz-10-in-1-250ml",
   "title": "KYO Style System 10-in-1 Leave-in-Conditioner – 250 ml",
   "groups": [
    "conditioner",
    "frizzSmoothing",
    "heatProtection"
   ],
   "strong": [],
   "role": "Pflege",
   "rank": 60
  },
  {
   "url": "/products/regenerierendes-haarserum-arganol-spirulina-spliss-schutz",
   "title": "Black Professional Line Doré Haarserum mit Arganöl 50 ml",
   "groups": [
    "moisture",
    "frizzSmoothing",
    "repair"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Pflege",
   "rank": 61
  },
  {
   "url": "/products/anti-gelb-conditioner-blond-pflege-500ml",
   "title": "Black Professional Line Yellow Stop – Anti-Gelb-Conditioner, 500 ml",
   "groups": [
    "conditioner",
    "antiYellow"
   ],
   "strong": [
    "antiYellow"
   ],
   "role": "Pflege",
   "rank": 62
  },
  {
   "url": "/products/styling-gel-locken-definition-frizz-kontrolle-250ml",
   "title": "KYO Curly System Shape Curly Lockengel – 250 ml",
   "groups": [
    "curl",
    "stylingHold"
   ],
   "strong": [
    "curl",
    "stylingHold"
   ],
   "role": "Finish",
   "rank": 63
  },
  {
   "url": "/products/bonacure-moisture-kick-spray-conditioner",
   "title": "Schwarzkopf Professional Bonacure Moisture Kick – Leave-in-Spray-Conditioner, 400 ml",
   "groups": [
    "conditioner",
    "moisture",
    "curl"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Pflege",
   "rank": 64
  },
  {
   "url": "/products/haarol-leave-in-ol-keratin-frizz-kontrolle",
   "title": "KYO Restruct System Crystals Haaröl mit Keratin – 100 ml",
   "groups": [
    "repair",
    "frizzSmoothing"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 65
  },
  {
   "url": "/products/restrukturierungs-vials-reisprotein-keratin-haarbruch-12x10ml",
   "title": "Evelon Pro Restructuring Vials – Repair-Ampullen mit Reisprotein und Keratin, 12 × 10 ml",
   "groups": [
    "repair"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 66
  },
  {
   "url": "/products/intensiv-repair-vials-royal-jelly-tiefenreparatur-geschadigtes-haar",
   "title": "Parisienne Evelon Royal Jelly Haarampullen – 12 × 10 ml",
   "groups": [
    "repair"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 67
  },
  {
   "url": "/products/staerkendes-shampoo-haarwurzel-kraeftigung",
   "title": "Black Professional Line Stärkendes Shampoo mit Plazentaextrakt, 500 ml",
   "groups": [
    "cleansing",
    "repair",
    "volume",
    "moisture"
   ],
   "strong": [
    "repair"
   ],
   "role": "Reinigung",
   "rank": 68
  },
  {
   "url": "/products/glanz-shampoo-b3-plex-keravis-sulfatfrei",
   "title": "Black Professional Line Argent – Glanz-Shampoo mit B3-PLEX",
   "groups": [
    "cleansing",
    "repair"
   ],
   "strong": [
    "repair"
   ],
   "role": "Reinigung",
   "rank": 69
  },
  {
   "url": "/products/luxe-oel-leave-in-keratinschutz-arganoel-geschmeidigkeit",
   "title": "Wella SP LuxeOil Reconstructive Elixir Haaröl – 100 ml",
   "groups": [
    "volume",
    "repair"
   ],
   "strong": [],
   "role": "Pflege",
   "rank": 70
  },
  {
   "url": "/products/veredelnde-maske-b3-plex-ceramide-leinsamenoel",
   "title": "Black Professional Line Argent – Haarmaske mit B3-PLEX",
   "groups": [
    "mask",
    "repair",
    "moisture"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 71
  },
  {
   "url": "/products/staerkende-haar-ampullen-haarwurzel-vitalisierung",
   "title": "Black Professional Line Stärkende Kopfhaut-Ampullen mit Plazentaextrakt, 12 × 10 ml",
   "groups": [
    "repair"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 72
  },
  {
   "url": "/products/farbschutz-maske-farbbrillanz-farbverschiebung-auswaschung-schuetzen",
   "title": "Wella SP Color Save Farbschutzmaske – 400 ml",
   "groups": [
    "mask",
    "colorCare",
    "moisture",
    "repair"
   ],
   "strong": [
    "colorCare"
   ],
   "role": "Pflege",
   "rank": 73
  },
  {
   "url": "/products/repair-booster-leave-in-haarfaser-rekonstruktion-12x10ml",
   "title": "Black Professional Line Perlé Keratin-Booster Haarampullen 12 × 10 ml",
   "groups": [
    "repair"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "rank": 74
  },
  {
   "url": "/products/feuchtigkeitsmaske-trockenes-kraeftiges-haar",
   "title": "Wella SP Hydrate Feuchtigkeitsmaske – 400 ml",
   "groups": [
    "mask",
    "moisture"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Pflege",
   "rank": 75
  },
  {
   "url": "/products/anti-yellow-maske-silber-glanz-blondes-graues-haar",
   "title": "Schwarzkopf BC Bonacure Color Freeze Silver Treatment Silbermaske 500 ml",
   "groups": [
    "mask",
    "antiYellow",
    "colorCare"
   ],
   "strong": [
    "antiYellow"
   ],
   "role": "Pflege",
   "rank": 76
  },
  {
   "url": "/products/volumen-haarmaske-koerper-fuelle-feines-haar-schwerelos",
   "title": "Wella Professionals INVIGO Volume Boost Crystal Mask 500 ml",
   "groups": [
    "mask",
    "volume",
    "moisture",
    "repair"
   ],
   "strong": [
    "volume"
   ],
   "role": "Pflege",
   "rank": 77
  },
  {
   "url": "/products/black-professional-arganoel-shampoo-pflege-1000-250ml",
   "title": "Black Professional Line Argan Treatment – Shampoo mit Arganöl",
   "groups": [
    "cleansing",
    "mask",
    "moisture",
    "repair"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 78
  },
  {
   "url": "/products/volumengebendes-shampoo-bambus-extrakt-feines-haar-volumen",
   "title": "Black Professional Line Blanc Volumenshampoo mit Bambusextrakt",
   "groups": [
    "cleansing",
    "volume"
   ],
   "strong": [
    "volume"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 79
  },
  {
   "url": "/products/volumisierende-maske-bambus-extrakt-lebloses-haar-volumen",
   "title": "Black Professional Line Blanc Volumenmaske mit Bambusextrakt",
   "groups": [
    "mask",
    "volume"
   ],
   "strong": [
    "volume"
   ],
   "role": "Pflege",
   "bulk": true,
   "rank": 80
  },
  {
   "url": "/products/anti-yellow-maske-silberblond-violette-pigmente",
   "title": "Black Professional Line Platinum No Yellow – Anti-Gelb-Haarmaske",
   "groups": [
    "mask",
    "antiYellow",
    "moisture",
    "repair",
    "volume"
   ],
   "strong": [
    "antiYellow"
   ],
   "role": "Pflege",
   "bulk": true,
   "rank": 81
  },
  {
   "url": "/products/farbschutz-shampoo-sulfatfrei-anti-fading-granatapfel-extrakt",
   "title": "Black Professional Line Rouge Color Lock Farbschutzshampoo, sulfatfrei",
   "groups": [
    "cleansing",
    "colorCare"
   ],
   "strong": [
    "colorCare"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 82
  },
  {
   "url": "/products/anti-yellow-shampoo-gelb-neutralisation-sulfatfrei",
   "title": "Black Professional Line Platinum No Yellow Silbershampoo",
   "groups": [
    "cleansing",
    "antiYellow",
    "colorCare"
   ],
   "strong": [
    "antiYellow"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 83
  },
  {
   "url": "/products/curly-dream-maske-locken-bio-baobaoel-frizz-kontrolle",
   "title": "Black Professional Line Rose Curly Dream Lockenmaske",
   "groups": [
    "mask",
    "curl",
    "moisture",
    "frizzSmoothing",
    "repair"
   ],
   "strong": [
    "curl"
   ],
   "role": "Pflege",
   "bulk": true,
   "rank": 84
  },
  {
   "url": "/products/farbschutz-maske-anti-fading-color-lock",
   "title": "Black Professional Line Rouge Color Lock Farbschutzmaske",
   "groups": [
    "mask",
    "colorCare",
    "moisture",
    "repair"
   ],
   "strong": [
    "colorCare"
   ],
   "role": "Pflege",
   "bulk": true,
   "rank": 85
  },
  {
   "url": "/products/farbschutz-shampoo-clr-color-system-coloriertes-haar",
   "title": "Evelon Pro CLR Color System Farbschutzshampoo – 1000 ml",
   "groups": [
    "cleansing",
    "colorCare"
   ],
   "strong": [
    "colorCare"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 86
  },
  {
   "url": "/products/locken-shampoo-lockenpflege-hyaluronsaeure-reiswasser-grossgebinde",
   "title": "KYO Curly System Locken-Shampoo – 1000 ml",
   "groups": [
    "cleansing",
    "curl",
    "frizzSmoothing"
   ],
   "strong": [
    "curl"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 87
  },
  {
   "url": "/products/glaettendes-shampoo-anti-frizz-sls-frei-grossgebinde",
   "title": "KYO Smooth System Anti-Frizz-Shampoo – 1000 ml",
   "groups": [
    "cleansing",
    "frizzSmoothing"
   ],
   "strong": [
    "frizzSmoothing"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 88
  },
  {
   "url": "/products/trockenes-haar-shampoo-farbschutz-parabenfrei-grossgebinde",
   "title": "KYO Hydra System Shampoo für trockenes und coloriertes Haar – 1000 ml",
   "groups": [
    "cleansing",
    "moisture",
    "colorCare"
   ],
   "strong": [
    "moisture",
    "colorCare"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 89
  },
  {
   "url": "/products/naehrende-haarmaske-arganoel-grossgebinde-1000ml",
   "title": "Black Professional Line Doré Haarmaske mit Arganöl – 1000 ml",
   "groups": [
    "mask",
    "moisture"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Pflege",
   "bulk": true,
   "rank": 90
  },
  {
   "url": "/products/naehrendes-shampoo-arganoel-grossgebinde-1000ml",
   "title": "Black Professional Line Doré Shampoo mit Arganöl – 1000 ml",
   "groups": [
    "cleansing",
    "moisture"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 91
  },
  {
   "url": "/products/bc-bonacure-color-freeze-silver-treatment",
   "title": "Schwarzkopf Professional Bonacure Color Freeze Silver Treatment – Haarmaske, 500 ml",
   "groups": [
    "mask",
    "antiYellow",
    "colorCare"
   ],
   "strong": [
    "antiYellow"
   ],
   "role": "Pflege",
   "bulk": true,
   "rank": 92
  },
  {
   "url": "/products/farbschutz-shampoo-farbintensitaet-coloriertes-haar-3d-protect",
   "title": "Wella SP Color Save Farbschutzshampoo – 1000 ml",
   "groups": [
    "cleansing",
    "colorCare"
   ],
   "strong": [
    "colorCare"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 93
  },
  {
   "url": "/products/naehrendes-anti-frizz-shampoo-grossgebinde-10l-baobaboel",
   "title": "Evelon Pro Nutri Elements Nährendes Anti-Frizz-Shampoo mit Bio-Baobaböl – 10 L",
   "groups": [
    "cleansing",
    "moisture",
    "frizzSmoothing",
    "repair"
   ],
   "strong": [
    "moisture",
    "frizzSmoothing"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 94
  },
  {
   "url": "/products/pflegespuelung-glanz-volumen-milchproteine-grossgebinde-5l",
   "title": "Herfit Pro Conditioner mit Milchproteinen – 5 L",
   "groups": [
    "conditioner",
    "repair",
    "moisture",
    "volume"
   ],
   "strong": [
    "repair"
   ],
   "role": "Pflege",
   "bulk": true,
   "rank": 95
  },
  {
   "url": "/products/anti-yellow-shampoo-gelb-neutralisation-silber-shampoo",
   "title": "Schwarzkopf Professional Bonacure Color Freeze Silver – Silbershampoo, 1000 ml",
   "groups": [
    "cleansing",
    "antiYellow"
   ],
   "strong": [
    "antiYellow"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 96
  },
  {
   "url": "/products/feuchtigkeitsspendendes-shampoo-trockenes-haar",
   "title": "Wella SP Hydrate Feuchtigkeitsshampoo – 1000 ml",
   "groups": [
    "cleansing",
    "moisture"
   ],
   "strong": [
    "moisture"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 97
  },
  {
   "url": "/products/bc-bonacure-color-freeze-shampoo",
   "title": "Schwarzkopf Professional Bonacure Color Freeze – Farbschutz-Shampoo, 1000 ml",
   "groups": [
    "cleansing",
    "colorCare"
   ],
   "strong": [
    "colorCare"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 98
  },
  {
   "url": "/products/volumen-shampoo-natuerliche-fuelle-feines-haar-baumwoll-extrakt",
   "title": "Wella Professionals Invigo Volume Boost Volumenshampoo 1000 ml",
   "groups": [
    "cleansing",
    "volume"
   ],
   "strong": [
    "volume"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 99
  },
  {
   "url": "/products/universelles-shampoo-10l-grossgebinde-alle-haartypen",
   "title": "Herfit Pro Hydrate Shampoo mit Milchproteinen 10 l",
   "groups": [
    "cleansing",
    "moisture",
    "repair"
   ],
   "strong": [
    "moisture",
    "repair"
   ],
   "role": "Reinigung",
   "bulk": true,
   "rank": 100
  },
  {
   "url": "/products/plex-protein-treatment-frizz-glatzung-filler-effekt-coloriertes-haar",
   "title": "Dr. Kalla Plex Protein-Haarkur für coloriertes Haar – 1000 ml",
   "groups": [
    "mask",
    "repair",
    "colorCare",
    "frizzSmoothing",
    "moisture"
   ],
   "strong": [
    "repair",
    "colorCare"
   ],
   "role": "Pflege",
   "bulk": true,
   "rank": 101
  }
 ]
};
